import { render, staticRenderFns } from "./ContestReadOnlyOfferBudgetView.vue?vue&type=template&id=15bf4778&scoped=true&"
import script from "./ContestReadOnlyOfferBudgetView.vue?vue&type=script&lang=js&"
export * from "./ContestReadOnlyOfferBudgetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf4778",
  null
  
)

export default component.exports